import React, {useState} from "react"

function HomePage() {
    return ( 
        <div>
            <h1>About</h1>
        </div>
    );
}

export default HomePage;